// extracted by mini-css-extract-plugin
export default {"processingDirection":"Loading_processingDirection","animatedBackground":"Loading_animatedBackground"};